export default __webpack_public_path__ + "static/media/placedIcon.41372a0b.svg";